// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "aiMoveWorker" + "." + "8247c3f9" + ".chunk.js";
};